import { computed, ref, watch } from 'vue';
import DobleFactorAuth from '../../../../../common/domain/constantes/DobleFactorAuth';
import store from '../../../../../common/infrastructure/almacen';
import HelperUtils from '../../../../../common/infrastructure/funciones/HelperUtils';
import { Actions } from '../../../../../common/infrastructure/almacen/enums/StoreEnums';
import { Container } from 'inversify';

import { CookieService, MessageService } from '../../../../../common/infrastructure/servicios';
import { MessageType } from '../../../../../common/infrastructure/servicios/MessageService';


export default {
    name: 'dobleFactor',
    props: {
        routes: Object,
        showModalAuthTypeChild: Boolean,
          container: {
            type: Object as () => Container            
        }, 
        showModalAuthType: Boolean,
        canClose: {
            type: Boolean,
            default: true
        },
    },
    emits: ['update:showModalAuthTypeChild'],
    setup(props, { emit }) {

        let showModalAuthType = ref(true);
        showModalAuthType.value = true;//props.showModalAuthType;
        let picked_two_factor = ref(false);
        let showEnterCode = ref(false);
        let checkedValue = ref<number>()
        let selectedFactorAuthType = ref('')
        let inputCode = ref('')
        let isLoading = ref<boolean>(false);
      
        /*watch(
            showModalAuthType, (oldvalue, newvalue) => {
                showModalAuthType.value = newvalue;
                emit('update:showModalAuthTypeChild', newvalue)
            },
            {
                flush: 'post',
                //immediate: true, 
                deep: true
            }
        )*/
        
        const getDobleFactorAuthOptions = computed(() => {
            
            var options = (store.getters.getCurrentUser.configuraciones.configuraciones.find((c: { idClave: string; valor: string; }) =>
                                                                                            c.idClave == 'cfgbroker-MFA'
                                                                                        )?.valor ?? '').split(',')
                                                                                        
            options = options.filter((o: string) => o != DobleFactorAuth.SMS || (o == DobleFactorAuth.SMS && store.getters.getCurrentUser.phone != null))
            
            return options;
        })

        function showModalEnterCode(_selectedFactorAuthType: string) {
            setDobleFactorUserCode(_selectedFactorAuthType);
            showEnterCode.value = true;
            showModalAuthType.value = false;
        }

        /*const cliente = computed({
            get: () => props.showModalAuthType,
            set: (val) => emit('update:showModalAuthTypeChild', val),
        });*/

        function confirmCode() {
            var _code = store.getters.getDobleFactorCode;
            var _dobleFactorCodeFechaCaducidad = store.getters.getDobleFactorCodeFechaCaducidad;

            if (!_dobleFactorCodeFechaCaducidad || (new Date(_dobleFactorCodeFechaCaducidad) < new Date())) {
                MessageService.showMessage(MessageType.Error, 'Error de validación', 'El código ha caducado.');
            }
            else if (_code == inputCode.value.trim()) {

                confirmDobleFactorUserCodeByMail();
            }
            else {
                MessageService.showMessage(MessageType.Error, 'Error de validación', 'Código no válido.');
            }
        }

        function confirmDobleFactorUserCodeByMail() {
            setTimeout(() => {
                isLoading.value = true;
                //cargando.value.mostrar();
                store
                    .dispatch(Actions.CONFIRM_DOBLE_FACTOR_USER, [store.getters.getCurrentUser.id, props.container])
                    .then(() => {                            
                        
                        CookieService.setCookie(CookieService.COOKIE_DOBLEFACTOR, 'Ok', 60 * 60 * 24 * 30); // 30 días
                        
                        var initUrl = store.getters.initUrlPage;
                        if (initUrl == '') {
                            const id = HelperUtils.newGuid();
                            props.routes?.push({ name: 'rfps', params: { id: id, operation: 'productos' } });
                        } else {
                            props.routes?.push({ name: 'mipanel' });
                        }
                    })
                    .finally(() => {
                        isLoading.value = false;
                        //(cargando.value).ocultar();
                    });
            }, 500);
        }

        function setDobleFactorUserCode(dobleFactorType: string) {
            setTimeout(() => {
                isLoading.value = true;
                //cargando.value.mostrar();
                store
                    .dispatch(Actions.SET_DOBLE_FACTOR_USER_CODE, [store.getters.getCurrentUser.id, dobleFactorType, props.container])
                    .then(() => {                            
                        
                    })
                    .finally(() => {
                        isLoading.value = false;
                        //(cargando.value).ocultar();
                    });
            }, 500);
        }

        function hideModalEnterCode(_selectedFactorAuthType: string) {
            switch (_selectedFactorAuthType) {
                case DobleFactorAuth.APP:
                    break;
                case DobleFactorAuth.EMAIL:
                    //showEnterCode.value = false;
                    break;
                case DobleFactorAuth.SMS:
                    break;
            }

            showEnterCode.value = false;
            selectedFactorAuthType.value = '';
            checkedValue.value = -1;
            showModalAuthType.value = true;
        }

        function chooseTwoFactorType(index: number, _selectedFactorAuthType: string) {
            checkedValue.value = index;
            selectedFactorAuthType.value = _selectedFactorAuthType;
        }

        function getAutenticatorTitle(optionType: string) {
            switch (optionType) {
                case DobleFactorAuth.APP:
                    return "Autenticación con aplicación.";
                case DobleFactorAuth.EMAIL:
                    return "Autenticación por correo.";
                case DobleFactorAuth.SMS:
                    return "Autenticación por SMS.";
            }
        }

        function getAutenticatorDescription(optionType: string) {
            switch (optionType) {
                case DobleFactorAuth.APP:
                    return "Obtiene código mediante una aplicación Móvil de autenticación.";
                case DobleFactorAuth.EMAIL:
                    return "Obtiene código mediante una cuenta de correo.";
                case DobleFactorAuth.SMS:
                    return "Obtiene código mediante el envío de un SMS.";
            }
        }
  
        function getAutenticatorIcon(optionType: string) {
            switch (optionType) {
                case DobleFactorAuth.APP:
                    return "ki-duotone ki-setting-2 fs-4x me-4 pi pi-microsoft";
                case DobleFactorAuth.EMAIL:
                    return "ki-duotone ki-setting-2 fs-4x me-4 pi pi-inbox";
                case DobleFactorAuth.SMS:
                    return "ki-duotone ki-setting-2 fs-4x me-4 pi pi-envelope";
            }
        }

  
      return {
        showModalEnterCode,
        hideModalEnterCode,
        showEnterCode,
        checkedValue,
        selectedFactorAuthType,
        getAutenticatorTitle,
        getAutenticatorDescription,
        chooseTwoFactorType,
        picked_two_factor,
        getDobleFactorAuthOptions,
        inputCode,
        confirmCode,
        showModalAuthType,
        isLoading,
        getAutenticatorIcon
      }
    }
  }

